import React, { Fragment, useState } from "react";
import { MDBIcon } from "mdbreact";
import { useHistory, useLocation } from "react-router-dom";
import "../../activities.scss";
import NoResult from "../../no_result/no_result";

type NewsDetailProps = {
  news: {
    id: number;
    title: string;
    description: string;
    created_at: string;
  };
  months: string[];
};

const CareerDetails = (props: NewsDetailProps) => {
  let history: any = useHistory();
  let location: any = useLocation();
  let companyName = location.pathname.split("/")[1];

  const clickLocation = () => {
    history.push(`/${companyName}/activities/news`);
  };
  return (
    <Fragment>
      {props.news ? (
        <div className="activity" key={props.news.id}>
          <div className="goback">
            <span onClick={() => clickLocation()}>back</span>
          </div>
          <div className="activity-title details">{props.news.title}</div>
          <div className="below-title">
            <span className="date">
              <MDBIcon far icon="calendar-alt" />{" "}
              {props.news.created_at.split(" ")[0]}
            </span>
          </div>
          <div className="activity-description active">
            <div
              className="description"
              dangerouslySetInnerHTML={{ __html: props.news.description }}
            />
          </div>
        </div>
      ) : (
        <NoResult title="data" />
      )}
    </Fragment>
  );
};

export default CareerDetails;
